import React, { memo } from "react";
import { Position } from "@xyflow/react";
import { SourceNodeData } from "../flow-utils";
import CircleButton from "widgets/controls/buttons/circle-button";
import RectangleHandle from "../../handles/rectangle";
import { TbCircleLetterS } from "react-icons/tb";

const SourceNode = (props: { data: SourceNodeData }) => {
  const { data } = props;

  return (
    <div
      className={`border-stone-400 min-w-52 rounded-3xl border-2  bg-white px-4 py-2 shadow-lg`}
      style={{ width: data.width, height: data.height }}
      key={data.id}
    >
      {/* Node content */}
      <div className="flex h-full flex-col justify-between p-1">
        <div className="flex justify-between">
          {/* Node main content */}
          <div>
            <div
              className="truncate text-lg font-bold text-primary"
              style={{ maxWidth: data.width - 10 }}
            >
              {data.name}
            </div>
            {data.device && (
              <div
                className="truncate text-xs text-secondary"
                style={{ maxWidth: data.width - 10 }}
              >
                SNR: {data.device.snr}
              </div>
            )}
          </div>

          {/* Menu buttons */}
          <div className="">
            <TbCircleLetterS className="text-3xl text-green-500" />
          </div>
        </div>
        {/* Bottom buttons - only in builder mode */}
        {data.onDelete && (
          <div className="flex justify-end">
            <CircleButton
              label="REMOVE"
              size="xs"
              color="red"
              onClick={() => {
                data.onDelete?.(data.id);
              }}
            />
          </div>
        )}
      </div>

      {/* Source handle */}
      <RectangleHandle
        type="source"
        position={data.sourcePosition ?? Position.Right}
        width={data.width}
        height={data.height}
      />
    </div>
  );
};

export default memo(SourceNode);
